//Used to compare arrays or objects values instead of reference values
//Using Json stringify to convert values to string to prevent comparing reference values


export const isEqual = (value, compareWithValue) => {

    return JSON.stringify(value) == JSON.stringify(compareWithValue)
} 